import { ensureVisible, exclusiveBind, toggleClassList } from './common/common';

document.addEventListener('DOMContentLoaded', function () {
  tgl_initToggle();
});

window.addEventListener('load', function () {
  tgl_setExpandedByAnchor();
});

document.addEventListener('domupdate', function () {
  tgl_initToggle();
});

/**
 * Expandera fäll ut/fäll ihop-panel (sidlistningsblock) baserat på ankare (#<block-id>:<sid-id> i url)  
 */
function tgl_setExpandedByAnchor() {
  if (window.location.hash.length === 0) {
    return;
  }

  // If hash link to panel
  var hashID = window.location.hash.replace('#', '');
  var hashLinkSelector = ".page-list [id='" + hashID + "']";
  var togglePanelList = document.querySelectorAll(hashLinkSelector);

  if (togglePanelList.length === 0) {
    return;
  }
  var togglePanel = togglePanelList[0].nextElementSibling;
  if (togglePanel && togglePanel.classList.contains('toggle-list__item')) {
    togglePanel.classList.add('hash-target');
    showHidePanel(togglePanel);
    if (togglePanel.querySelector('.toggle-list__expand-target--expanded')) {
      ensureVisible(togglePanel, { alignWithTop: true });
    }
  }
}

/**
 * Bind togglingslogik 
 */
function tgl_initToggle() {
  var togglePanels = document.querySelectorAll('div.toggle-panel');

  togglePanels.forEach(function (togglePanel) {
    initTogglePanel(togglePanel);
  });

  tgl_initToggleLinks();
}

/**
 * Init toggle panel.
 */
function initTogglePanel(togglePanel) {
  // Kontrollera att toggel-länk finns, 
  // om inte skapas en utifrån första heading-element    
  var toggleLinkEls = togglePanel.querySelectorAll('a.toggleLink, a.expandLink');
  if (toggleLinkEls.length > 0) {
    return;
  }

  var heading;
  var children = togglePanel.children;

  for (var i = 0; i < children.length; i++) {
    var tagName = children[i].tagName.toLowerCase();
    if (tagName === 'h1' || tagName === 'h2' || tagName === 'h3' || tagName === 'h4' || tagName === 'h5' || tagName === 'h6') {
      heading = children[i];
      break;
    }
  }

  //om heading saknas i panel, leta rubrik 
  //bland panelens syskonelement
  if (!heading) {
    var sibling = togglePanel.previousElementSibling;

    while (sibling) {
      var tagName = sibling.tagName.toLowerCase();
      if (tagName === 'h1' || tagName === 'h2' || tagName === 'h3' || tagName === 'h4' || tagName === 'h5' || tagName === 'h6') {
        heading = sibling;
        break;
      }
      sibling = sibling.previousElementSibling;
    }
    if (heading) {
      //heading måste flyttas in i panel
      togglePanel.insertBefore(heading, togglePanel.firstChild);
    }
  }

  //avbryt om heading fortfarande saknas
  if (!heading) {
    return;
  }

  //skapa toggle-länk runt första rubrik i panelen
  var toggleLink = document.createElement('a');
  toggleLink.href = '#';
  toggleLink.className = 'expandLink';
  toggleLink.textContent = heading.textContent;
  heading.textContent = '';
  heading.appendChild(toggleLink);

  //flytta alla syskonelement efter toggle-länk till div som togglas
  var toggleTarget = document.createElement('div');
  toggleTarget.className = 'expandTarget';
  while (heading.nextSibling) {
    toggleTarget.appendChild(heading.nextSibling);
  }
  togglePanel.appendChild(toggleTarget);

  //om hashlänk till panel
  var hashLinkSelector = 'a[name=' + window.location.hash.replace('#', '') + ']';
  var isHashTarget = (window.location.hash.length > 0 && togglePanel.querySelector(hashLinkSelector));

  if (togglePanel.classList.contains('init-expanded')) {
    toggleLink.classList.add('expanded');
    toggleTarget.classList.add('expanded');

    if (isHashTarget) {
      togglePanel.classList.add('hashtarget');
      //flytta bokmärke så att hela panelen syns
      togglePanel.parentNode.insertBefore(isHashTarget, togglePanel);
    }
  }
}

function tgl_initToggleLinks() {
  var links = document.querySelectorAll('a.expandLink, a.toggle-list__expand-link');
  links.forEach(function (link) {
    exclusiveBind(link, 'click', tgl_toggleLinkClickHandler);
  });
}

/**
 * Hantera klick på togglellänk  
 */
function tgl_toggleLinkClickHandler(evt) {
  evt.preventDefault();
  var currentTarget = evt.currentTarget;
  //närmaste div ska vara toggle-container
  var container = currentTarget.closest('.avoid-equalized');
  if (container && !container.classList.contains('avoid-equalized--avoided')) {
    var style = window.getComputedStyle(container);
    container.style.minHeight = style.height;
    container.classList.add('avoid-equalized--avoided');
  }
  toggleClassList(currentTarget, 'is-rotated');
  var closestDiv = currentTarget.closest('div');
  showHidePanel(closestDiv);
}

function showHidePanel(togglePanel) {
  var toggleTarget = togglePanel.querySelector('.expandTarget, .toggle-list__expand-target');
  if (!toggleTarget) {
    return;
  }

  if (getComputedStyle(toggleTarget).display !== 'none') {
    toggleTarget.style.display = 'none';
  } else {
    toggleTarget.style.display = '';
  }

  var defaultExpandedClass = 'expanded';

  //get toggle class from target
  toggleClass = toggleTarget.getAttribute('data-toggle-class') || defaultExpandedClass;
  toggleClassList(toggleTarget, toggleClass);

  var toggleLink = togglePanel.querySelector('h2 a, h3 a');
  if (toggleLink) {
    //get toggle class from link
    var toggleClass = toggleLink.getAttribute('data-toggle-class') || defaultExpandedClass;
    toggleClassList(toggleLink, toggleClass);
  }
}
